import {GetterTree, MutationTree , ActionTree} from "vuex";

export const namespaced = true;

export interface WareInfoState {
    features_tab : string;
    manual_tab : string;
    service_center_tab : string;

    show_voucher_modal : boolean;
}

/**
 * state
 */
export const state : WareInfoState = {
    features_tab : "",
    manual_tab : "",
    service_center_tab : "",

    show_voucher_modal : false,
};

/**
 * getters
 */
export const getters: GetterTree<WareInfoState, any> = {
    
    getFeaturesTab: (state) => {
        return state.features_tab;
    },

    getManualTab: (state) => {
        return state.manual_tab;
    },
    
    getServiceCenterTab: (state) => {
        return state.service_center_tab;
    },

    isShowVoucherModal: (state) => {
        return state.show_voucher_modal;
    },

};

/**
 * actions
 */
export const actions: ActionTree<WareInfoState, WareInfoState> = {

    doSetFeaturesTab: ({commit, state}, features_tab : string) => {
        commit("setFeaturesTab", features_tab);
    },

    doSetManualTab: ({commit, state}, manual_tab : string) => {
        commit("setManualTab", manual_tab);
    },

    doSetServiceCenterTab: ({commit, state}, service_center_tab : string) => {
        commit("setServiceCenterTab", service_center_tab);
    },

    doSetShowVoucherModal: ({commit, state}, show_voucher_modal : boolean) => {
        state.show_voucher_modal = show_voucher_modal;
    },

};

/**
 * mutations
 */
export const mutations: MutationTree<WareInfoState> = {

    setWareInfo: (state, payload : WareInfoState) => {
        state.features_tab       = payload.features_tab;
        state.manual_tab         = payload.manual_tab;
        state.service_center_tab = payload.service_center_tab;
    },

    setFeaturesTab: (state, payload : string) => {
        state.features_tab = payload;

        // 세션에 ware_info 추가
        if( sessionStorage != null ){
            sessionStorage.setItem("ware_info", JSON.stringify(state));
        }
    },

    setManualTab: (state, payload : string) => {
        state.manual_tab = payload;

        // 세션에 ware_info 추가
        if( sessionStorage != null ){
            sessionStorage.setItem("ware_info", JSON.stringify(state));
        }
    },

    setServiceCenterTab: (state, payload : string) => {
        state.service_center_tab = payload;

        // 세션에 ware_info 추가
        if( sessionStorage != null ){
            sessionStorage.setItem("ware_info", JSON.stringify(state));
        }
    },

};